module.exports = __webpack_public_path__ + "db-logomark.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/db-logomark.svg
// module id = F+6J
// module chunks = 0